import { n as now, r as random, w as warn } from './lib/6cf04c83.mjs';
import { i as isPlainObject, e as extend } from './lib/085c42f3.mjs';
import { e as evalScript } from './lib/858712b6.mjs';
import './lib/111f4418.mjs';

function setResponseType(options, request) {
  if (options.responseType) {
    if (typeof request.responseType === "string") {
      try {
        request.responseType = options.responseType;
      } catch (error) {
      }
    }
  }
}
function setRequestTimeout(options, request) {
  if (options.timeout) {
    if (typeof request.timeout === "number") {
      request.timeout = options.timeout;
    } else {
      return setTimeout(request.abort, options.timeout);
    }
  }
  return void 0;
}
function handleRequestTimeout(abortTimeout) {
  if (abortTimeout) {
    clearTimeout(abortTimeout);
  }
}
function setContentType(options, request) {
  if (options.contentType) {
    request.setRequestHeader("Content-Type", options.contentType);
  }
}
function setHeaders(options, request) {
  if (options.headers) {
    Object.entries(options.headers).forEach(([h, v]) => {
      if (typeof v === "string") {
        request.setRequestHeader(h, v);
      }
    });
  }
}
function setWithCredentials(options, request) {
  if (typeof options.withCredentials === "boolean") {
    request.withCredentials = options.withCredentials;
  }
}
function sanitizeResponse(options, request) {
  if (!!options.responseType && options.responseType === "json" && !request.responseType) {
    if (request.responseText) {
      request.responseJSON = JSON.parse(request.responseText);
    }
  } else {
    request.responseJSON = request.response;
  }
}
function handleDone(handler) {
  return function doneHandler(ev) {
    if (this.readyState === XMLHttpRequest.DONE) {
      handler(this, ev);
    }
  };
}
function validateOptions(options) {
  if (!options) {
    return new Error("Parameter 'options' is missing.");
  }
  if (!options.method) {
    return new Error("Parameter 'options.method' is missing.");
  }
  if (!options.url) {
    return new Error("Parameter 'options.url' is missing.");
  }
  if (options.headers && !isPlainObject(options.headers)) {
    return new Error("Parameter 'options.headers' must be a key/value object if set");
  }
  return null;
}
function injectScript(xhr, executeImmediately, callback) {
  let script;
  if ((xhr.status === 200 || xhr.status === 304) && executeImmediately !== false) {
    script = document.createElement("script");
    script.type = "text/javascript";
    script.text = xhr.responseText;
    evalScript(script);
  }
  if (typeof callback === "function") {
    callback(xhr);
  }
  return xhr;
}
function getCustomTimeStamp() {
  return now().toString() + Math.floor(random() * 999).toString();
}
function sanitizeGetScriptOptions(url, options) {
  const opts = { executeImmediately: true, cacheBusting: true, url };
  if (typeof options === "boolean") {
    opts.executeImmediately = options;
  } else if (typeof options === "object") {
    if (typeof options.executeImmediately !== "undefined") {
      opts.executeImmediately = options.executeImmediately;
    }
    if (typeof options.cacheBusting !== "undefined") {
      opts.cacheBusting = options.cacheBusting;
    }
  }
  if (opts.cacheBusting) {
    opts.url = url.indexOf("?") !== -1 ? `${url}&_=${getCustomTimeStamp()}` : `${url}?_=${getCustomTimeStamp()}`;
  }
  return opts;
}
function sanitizePostOptions(data) {
  return typeof data === "object" ? {
    data: JSON.stringify(data),
    contentType: "application/json; charset=utf-8"
  } : {
    data,
    contentType: "application/x-www-form-urlencoded; charset=utf-8"
  };
}

function sendRequest(options, callback, counterObject) {
  const counter = counterObject;
  const request = new XMLHttpRequest();
  request.open(options.method.toUpperCase(), options.url, true);
  counter.active += 1;
  setResponseType(options, request);
  setContentType(options, request);
  setHeaders(options, request);
  setWithCredentials(options, request);
  const abortTimeout = setRequestTimeout(options, request);
  request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  const decrementCounter = () => {
    counter.active -= 1;
  };
  request.addEventListener("abort", decrementCounter);
  request.addEventListener("error", decrementCounter);
  request.onreadystatechange = handleDone(() => {
    handleRequestTimeout(abortTimeout);
    decrementCounter();
    sanitizeResponse(options, request);
    callback(request);
  });
  request.send(options.data ? options.data : null);
  return request;
}

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function ajaxBase(options, callback) {
  warn("o_util.ajax is deprecated use native fetch instead");
  const optionsError = validateOptions(options);
  if (typeof callback === "function") {
    if (optionsError instanceof Error) {
      throw optionsError;
    }
    return sendRequest(
      options,
      callback,
      ajax
    );
  }
  return new Promise((resolve, reject) => {
    if (optionsError instanceof Error) {
      reject(optionsError);
      return;
    }
    sendRequest(options, resolve, ajax);
  });
}
function get(url, callback) {
  return ajaxBase({ method: "GET", url }, callback);
}
function getJSON(url, callback) {
  return ajaxBase({ method: "GET", url, responseType: "json" }, callback);
}
function post(url, data, callback) {
  return ajaxBase(
    __spreadValues({
      method: "POST",
      url
    }, sanitizePostOptions(data)),
    callback
  );
}
function abort(xhr) {
  xhr.abort();
}
function getScript(url, options, callback) {
  const opts = sanitizeGetScriptOptions(url, options);
  return typeof callback === "function" ? ajaxBase(
    { method: "GET", url: opts.url },
    (xhr) => injectScript(xhr, opts.executeImmediately, callback)
  ) : ajaxBase({
    method: "GET",
    url: opts.url
  }).then((xhr) => injectScript(xhr, opts.executeImmediately));
}
const ajax = extend(
  ajaxBase,
  {
    get,
    getJSON,
    getScript,
    post,
    abort,
    active: 0,
    _getCustomTimeStamp: getCustomTimeStamp
  },
  false,
  false
);

export { ajax };
/*                             */
